import { Link } from "@tanstack/react-router";

const steps = [
  { n: 1, title: "Kontakt- und Projektdaten eingeben", sub: "In nur 2 Minuten erledigt", color: "bg-navy", icon: "M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-4 0-9 2-9 6v2h18v-2c0-4-5-6-9-6z" },
  { n: 2, title: "Unterlagen hochladen", sub: "Angebote oder Projektunterlagen", color: "bg-[var(--leaf-deep)]", icon: "M19 15v3H5v-3H3v5h18v-5h-2zM11 4v9.2l-3.6-3.6L6 11l6 6 6-6-1.4-1.4L13 13.2V4h-2z" },
  { n: 3, title: "Analyse & Vergleich", sub: "Unsere KI & Experten arbeiten", color: "bg-[var(--leaf)]", icon: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 14H9v-6h2v6zm4 0h-2V7h2v9z" },
  { n: 4, title: "Ergebnis erhalten", sub: "Ihre beste Entscheidung", color: "bg-orange", icon: "M3 17l6-6 4 4 8-8v6h2V3h-10v2h6.6l-6.6 6.6-4-4L1.4 15.6 3 17z" },
];

export function PublicProcess() {
  return (
    <section id="prozess" className="border-b border-[var(--rule)]" style={{ backgroundColor: "#d1d6e0" }}>
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-12 md:py-16">
        <h2 className="text-center font-display font-bold text-navy text-2xl md:text-3xl mb-10">
          Von der Projektidee zur optimalen Entscheidung
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-2 mb-12">


          {steps.map((s, i) => (
            <div key={s.n} className="flex items-center gap-3 relative">
              <div className="flex flex-col items-center gap-2 shrink-0">
                <span className={`w-12 h-12 rounded-full ${s.color} text-white font-display font-bold text-lg flex items-center justify-center`}>
                  {s.n}
                </span>
              </div>
              <div className="flex items-center gap-3 flex-1">
                <svg viewBox="0 0 24 24" className="w-8 h-8 text-[var(--leaf-deep)] shrink-0" fill="currentColor" aria-hidden>
                  <path d={s.icon} />
                </svg>
                <div className="min-w-0">
                  <div className="font-display font-semibold text-navy text-sm leading-tight">{s.title}</div>
                  <div className="text-xs text-navy/60 mt-0.5">{s.sub}</div>
                </div>
              </div>
              {i < steps.length - 1 && (
                <span className="hidden lg:block absolute -right-1 top-1/2 -translate-y-1/2 text-orange text-2xl">→</span>
              )}
            </div>
          ))}
        </div>

        {/* Two boxes: Angebote vergleichen / Projekt beschreiben */}
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-6 items-stretch">
          <div className="bg-white rounded-xl border-2 border-[var(--leaf)]/30 shadow-md p-6 flex flex-col">
            <div className="flex items-start gap-3 mb-3">
              <span className="w-11 h-11 rounded-full bg-[color-mix(in_oklab,var(--leaf)_15%,white)] inline-flex items-center justify-center shrink-0">
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-[var(--leaf-deep)]" fill="currentColor" aria-hidden>
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
              </span>
              <h3 className="font-display font-bold text-navy text-lg">Angebote vergleichen</h3>
            </div>
            <p className="text-sm text-navy/80 mb-4 leading-relaxed">
              Laden Sie Ihre Angebote hoch und wir vergleichen Leistungen, Preise, Qualität und Wirtschaftlichkeit.
            </p>
            <Link
              to="/projekt-beschreiben"
              search={{ mode: "upload" }}
              className="mt-auto block rounded-xl border-2 border-dashed border-[var(--leaf)]/50 bg-[color-mix(in_oklab,var(--leaf)_5%,white)] hover:bg-[color-mix(in_oklab,var(--leaf)_10%,white)] transition p-6 text-center"
            >
              <span className="mx-auto mb-3 inline-flex w-14 h-14 items-center justify-center rounded-full bg-[color-mix(in_oklab,var(--leaf)_15%,white)]">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-[var(--leaf-deep)]" fill="currentColor" aria-hidden>
                  <path d="M12 3l5 5h-3v6h-4V8H7l5-5zM5 18v2h14v-2H5z" />
                </svg>
              </span>
              <div className="font-display font-semibold text-navy text-sm">
                Dateien hierher ziehen oder klicken, um Dateien auszuwählen
              </div>
              <div className="mt-2 text-xs text-navy/60">
                Unterstützte Formate: PDF, DOCX, XLSX, PPTX, ZIP · Max. Dateigröße: 50 MB
              </div>
            </Link>
          </div>

          <div className="flex items-center justify-center">
            <span className="font-display font-bold text-navy/40 text-sm tracking-wider">ODER</span>
          </div>

          <div className="bg-white rounded-xl border-2 border-[var(--leaf)]/30 shadow-md p-6 flex flex-col">
            <div className="flex items-start gap-3 mb-3">
              <span className="w-11 h-11 rounded-full bg-[color-mix(in_oklab,var(--leaf)_15%,white)] inline-flex items-center justify-center shrink-0">
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-[var(--leaf-deep)]" fill="currentColor" aria-hidden>
                  <path d="M9 2h6a1 1 0 011 1v1h3a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h3V3a1 1 0 011-1zm1 2v2h4V4h-4zm-.3 13.3l-2.5-2.5 1.4-1.4 1.1 1.1 3.4-3.4 1.4 1.4-4.8 4.8z" />
                </svg>
              </span>
              <h3 className="font-display font-bold text-navy text-lg">Projekt beschreiben</h3>
            </div>
            <p className="text-sm text-navy/80 mb-4 leading-relaxed">
              Beschreiben Sie Ihr Vorhaben und laden Sie relevante Unterlagen hoch – wir analysieren alle Möglichkeiten.
            </p>
            <Link
              to="/projekt-beschreiben"
              className="mt-8 inline-flex items-center justify-center rounded-xl bg-[var(--leaf)] hover:bg-[var(--leaf-deep)] text-white font-semibold px-6 py-3 transition"
            >
              Projekt beschreiben
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
